module.exports = __webpack_public_path__ + "static/img/logo2.f28fd5cc.png";